//---------------------
// get character skill
//---------------------
export default function getCharacterSkill(skills,name) {

    const skills_found = skills.filter(s => s.name === name)
    if (skills_found.length > 0) {
        return skills_found[0]
    } else {
        return null
    }
}
